export default {
    actions: {
        manageIncluded({ commit }: any, included?: Array<any>) {
            if (included) {
                let strings = included.filter((item: any) => item.type == 'string')
                commit('strings', strings)
            }
        },
    },
}
